export const CART_SOURCES = {
  ORDER: 'order-cart',
  SALES_ORDER: 'sales-order-cart',
  INVOICING: 'invoicing-cart',
};

export const getLinesBySource = ({ source, orderCartLines = [], salesOrderCartLines = [], invoicingCartLines = [] }) => {
  if (source === CART_SOURCES.INVOICING) return Array.isArray(invoicingCartLines) ? invoicingCartLines : [];
  if (source === CART_SOURCES.SALES_ORDER) return Array.isArray(salesOrderCartLines) ? salesOrderCartLines : [];
  return Array.isArray(orderCartLines) ? orderCartLines : [];
};

export const resolveSalesOrderCartUnlocked = ({
  requireUnlock = false,
  unlocked = false,
} = {}) => !requireUnlock || unlocked;

export const canEditSource = (source, { salesOrderCartUnlocked = false } = {}) =>
  source !== CART_SOURCES.SALES_ORDER || salesOrderCartUnlocked;

export const saveTargetForSource = (source) => {
  if (source === CART_SOURCES.INVOICING) return 'invoicing-cart';
  if (source === CART_SOURCES.ORDER) return 'order-edit';
  return 'no-save';
};

export const applyServiceMutationBySource = ({ source, state, mutator, salesOrderCartUnlocked = false }) => {
  if (!canEditSource(source, { salesOrderCartUnlocked })) return state;
  if (source === CART_SOURCES.INVOICING) {
    return { ...state, invoicingCartLines: mutator(Array.isArray(state.invoicingCartLines) ? state.invoicingCartLines : []) };
  }
  if (source === CART_SOURCES.SALES_ORDER) {
    return { ...state, salesOrderCartLines: mutator(Array.isArray(state.salesOrderCartLines) ? state.salesOrderCartLines : []) };
  }
  return { ...state, orderCartLines: mutator(Array.isArray(state.orderCartLines) ? state.orderCartLines : []) };
};
